// This file is auto-generated. Do not edit manually.

import { z } from "zod";
import { ResponseMessageSchema, StatusSchema } from "./utilitySchemas";

export const LocationCandidateSchema = z.object({
  formattedAddress: z.string().min(1),
  latitude: z.number(),
  longitude: z.number(),
  geocodingProvider: z.literal("mapbox"),
  geocodingProviderId: z.string().min(1),
  metadata: z.object({
    provider: z.literal("mapbox"),
    mapboxFeatureId: z.string().min(1),
    formattedPlaceName: z.string().min(1),
    placeType: z.array(z.string()),
    relevance: z.number().nullable(),
    context: z.array(z.record(z.unknown())),
    bbox: z.array(z.number()).nullable(),
  }),
  addressComponents: z.object({
    streetName: z.string().nullable(),
    streetNumber: z.string().nullable(),
    postalCode: z.string().nullable(),
    city: z.string().nullable(),
    country: z.string().nullable(),
  }),
});
export type LocationCandidate = z.infer<typeof LocationCandidateSchema>;

export const LocationSearchResponseSchema = z.object({
  status: StatusSchema,
  message: ResponseMessageSchema,
  data: z.object({
    candidates: z.array(LocationCandidateSchema),
  }),
});
export type LocationSearchResponse = z.infer<typeof LocationSearchResponseSchema>;
